import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable, Subject } from 'rxjs/Rx';
import { UsersService } from '../services/users.service';
import * as firebase from 'firebase';
import swal from 'sweetalert2';

@Injectable()
export class AuthService {
  token: string;
  authState: any = null;
  authUserState: any = null;
  autoSignIn = true;
  currentAuthState: any;

  constructor(
    private angularFireAuth: AngularFireAuth,
    public router: Router,
    private userService: UsersService
  ) {
    this.angularFireAuth.authState.subscribe(auth => {
      if (auth) {
        if (this.autoSignIn) {
          this.userService
            .getOne(auth.uid)
            .then(res => {
              if (res.data()) {
                // console.log(res.data());
                if (res.data().type === 'admin' || res.data().type === 'superadmin') {
                  this.authState = auth;
                  this.router.navigate(['full-layout']);
                  swal({
                    type: 'success',
                    title: 'Sign In!',
                    html: 'sign in success',
                    showConfirmButton: false,
                    timer: 1000
                  });
                  // swal('Sign In!', 'sign in success', 'success');
                } else {
                  this.authUserState = auth;
                  this.router.navigate(['user']);
                  swal({
                    type: 'success',
                    title: 'Sign In!',
                    html: 'sign in success',
                    showConfirmButton: false,
                    timer: 1000
                  });

                  // this.authState = auth;
                  // this.router.navigate(['full-layout']);
                  // swal({
                  //   type: 'success',
                  //   title: 'Sign In!',
                  //   html: 'sign in success',
                  //   showConfirmButton: false,
                  //   timer: 1000
                  // });
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      } else {
        // this.router.navigate(['home']);
      }
    });
  }

  // checkTypeAuth(data) {
  //   this.userService.get(data.uid).subscribe((res: any) => {});
  // }

  get authenticated(): boolean {
    return this.authState !== null;
  }

  get userAuthenticated(): boolean {
    return this.authUserState !== null;
  }

  login(email: string, password: string) {
    return this.fromFirebaseAuthPromise(
      this.angularFireAuth.auth.signInWithEmailAndPassword(email, password)
    );
  }

  fromFirebaseAuthPromise(promise): Observable<any> {
    const subject = new Subject<any>();

    promise.then(
      res => {
        this.authState = res;
        subject.next(res);
        subject.complete();
      },
      err => {
        subject.error(err);
        subject.complete();
      }
    );

    return subject.asObservable();
  }

  loginUser(email: string, password: string) {
    return this.fromFirebaseAuthUserPromise(
      this.angularFireAuth.auth.signInWithEmailAndPassword(email, password)
    );
  }

  fromFirebaseAuthUserPromise(promise): Observable<any> {
    const subject = new Subject<any>();
    promise.then(
      res => {
        this.authUserState = res;
        subject.next(res);
        subject.complete();
      },
      err => {
        subject.error(err);
        subject.complete();
      }
    );

    return subject.asObservable();
  }
  // return this.auth.auth
  // .signInWithEmailAndPassword(email, password)
  // .then(value => {
  //   console.log('worked');
  //   return { status: true, data: value };
  // })
  // .catch(err => {
  //   console.log('wrong:', err.message);
  //   alert('wrong:' + err.message);
  //   return { status: false, data: err.message };
  // });

  signup(email: string, password: string, data, autoSignIn?: boolean) {
    if (autoSignIn === false) {
      this.autoSignIn = false;
      this.currentAuthState = { ...this.authState };
    }
    return new Promise(resolve => {
      this.angularFireAuth.auth
        .createUserWithEmailAndPassword(email, password)
        .then(async (value: any) => {
          const user = await firebase.auth().currentUser;
          // console.log(value);
          await user
            .sendEmailVerification()
            .then(resSentMail => {
              console.log('sent mail');
            })
            .catch(err => {
              console.log(err);
            });
          delete data.password;
          delete data.cpassword;
          data.id = value.user.uid;
          (data.email = value.user.email),
            (data.createDate = value.user.metadata.a),
            (data.lastUpdate = value.user.metadata.b),
            (data.photoURL = value.user.photoURL);
          data.displayName = data.displayName;
          await this.userService.create(value.user.uid, data);
          await resolve({ email: email, password: password });
        })
        .catch(err => {
          console.log('wrong:', err.message);
          resolve({ error: err.message });
          swal('Error!', err.message, 'error');
          // alert(err.message);
        });
    });
  }

  signinWithGoogle() {
    return new Promise(resolve => {
      this.angularFireAuth.auth
        .signInWithPopup(new firebase.auth.GoogleAuthProvider())
        .then(async (value: any) => {
          // console.log(value);
          const data = {
            id: '',
            email: '',
            createDate: '',
            lastUpdate: '',
            photoURL: '',
            displayName: '',
            type: 'user'
          };
          data.id = value.user.uid;
          (data.email = value.user.email),
            (data.createDate = value.user.metadata.a),
            (data.lastUpdate = value.user.metadata.b),
            (data.photoURL = value.user.photoURL);
          data.displayName = value.user.displayName;
          await this.userService
            .getOne(value.user.uid)
            .then(res => {
              if (res.data()) {
                return this.userService.update(value.user.uid, data);
              } else {
                const user = firebase.auth().currentUser;
                // console.log(value);
                // user
                //   .sendEmailVerification()
                //   .then(resSentMail => {
                //     console.log('sent mail');
                //   })
                //   .catch(err => {
                //     console.log(err);
                //   });
                this.userService
                  .create(value.user.uid, data)
                  .then(resCreate => {
                    // console.log(resUser);
                    this.userService.getOne(value.user.uid).then(resUser => {
                      // console.log(resUser.data());
                      user
                        .sendEmailVerification()
                        .then(resSentMail => {
                          console.log('sent mail');
                          window.location.reload();
                        })
                        .catch(err => {
                          console.log(err);
                          window.location.reload();
                        });
                      // this.authUserState = resUser.data();
                      // this.router.navigate(['home']);
                    });
                  })
                  .catch(err => {});
              }
            })
            .catch(err => {
              console.log(err);
            });

          await resolve({ email: value.user.email });
        })
        .catch(err => {
          console.log('wrong:', err.message);
          // swal('Error!', err.message, 'error');
          // alert(err.message);
        });
    });
  }

  signinWithFacebook() {
    return new Promise(resolve => {
      this.angularFireAuth.auth
        .signInWithPopup(new firebase.auth.FacebookAuthProvider())
        .then(async (value: any) => {
          console.log(value);
          const data = {
            id: '',
            email: '',
            createDate: '',
            lastUpdate: '',
            photoURL: '',
            displayName: ''
          };
          data.id = value.user.uid;
          (data.email = value.user.email),
            (data.createDate = value.user.metadata.a),
            (data.lastUpdate = value.user.metadata.b),
            (data.photoURL = value.user.photoURL);
          data.displayName = value.user.displayName;
          await this.userService.create(value.user.uid, data);
          await resolve({ email: value.user.email });
        })
        .catch(err => {
          console.log('wrong:', err.message);
          swal('Error!', err.message, 'error');
          // alert(err.message);
        });
    });
  }

  signout() {
    this.token = null;
    this.angularFireAuth.auth.signOut();
    this.router.navigate(['home']);

    // clear
    this.authState = null;
    this.authUserState = null;
  }

  // getToken() {
  //   return this.token;
  // }

  // isAuthenticated() {
  //   // here you can check if user is authenticated or not through his token
  //   return true;
  // }
}
